import React from 'react';
import Grid from '@material-ui/core/Grid';
import SeriesCompareScatterChart from './charts/SeriesCompareScatterChart';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import Badge from '@material-ui/core/Badge';
import Chip from '@material-ui/core/Chip';

class OptimizationInsight extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            };

        this.handleListItemClick = this.handleListItemClick.bind(this);
    }

    componentDidMount() {
        //new SankeyBarChart(`#${this.props.id}`, `${this.props.id}-svg`, this.props.data, { height: 150 });   
    }

    handleListItemClick(item)
    {
        alert('item was clicked');
    }

    render() {

        const { classes } = this.props;

        let index = 0;
        let chart = this.props.charts[index];
        return (
            <div>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <Typography>{chart.title}</Typography>
                        <SeriesCompareScatterChart width={800} height={400} {...this.props} key={chart.id + "_" + index} series={chart.series} />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default OptimizationInsight;


// WEBPACK FOOTER //
// ./src/components/OptimizationInsight.js